import Montecristo from '../../assets/images/our-companies/our-comp-img-montecristo.png';
import RomeoYJulieta from '../../assets/images/our-companies/our-comp-img-romeo.png';
import CasaDeMontecristo from '../../assets/images/our-companies/our-comp-img-CDM.png';
import ChaseTheAce from '../../assets/images/our-companies/our-comp-img-CTA.png';
import CigarsCom from '../../assets/images/our-companies/our-comp-img-cigars.png';
import SeriousCigars from '../../assets/images/our-companies/our-comp-img-serious.png';
import BeatTheDealer from '../../assets/images/our-companies/our-comp-img-BTD.png';
import SantaClara from '../../assets/images/our-companies/our-comp-img-SantaClara.png';
import JRcigars from '../../assets/images/our-companies/our-comp-img-JRCigars.png';
import MSC from '../../assets/images/our-companies/our-comp-img-MSC.png';
import AltadisUSA from '../../assets/images/our-companies/our-comp-img-altadis.png';

export const companies = [
  {
    company: "Altadis U.S.A.",
    name: "Altadis U.S.A.",
    info: "If you have ever enjoyed a premium cigar, there’s a good chance you’ve enjoyed a cigar by Altadis U.S.A., crafting great cigars since 1918.",
    link: "/our-companies/altadis-usa",
    image: AltadisUSA,
  },
  {
    company: "Altadis U.S.A.",
    name: "Montecristo",
    info: "Montecristo cigars are perhaps one of the most renowned and recognized cigar brands in the world.",
    link: "/our-companies/montecristo",
    image: Montecristo,
  },
  {
    company: "Altadis U.S.A.",
    name: "Romeo y Julieta",
    info: "Romeo y Julieta cigars have been sparking love affairs with adult cigar smokers for over three centuries.",
    link: "/our-companies/romeo-y-julieta",
    image: RomeoYJulieta,
  },
  {
    company: "Altadis U.S.A.",
    name: "Chase The Ace",
    info: "Chase the Ace, brought to you by Altadis U.S.A., is a new and exciting way to win coupons for discounts on Romeo y Julieta cigars. Play the game the cigar community is talking about!",
    link: "/our-companies/chase-the-ace",
    image: ChaseTheAce,
  },
  {
    company: "Altadis U.S.A.",
    name: "Montecristo Social Club",
    info: "The Montecristo Social Club is a members-only club dedicated to adult cigar enthusiasts and the cigar lifestyle.",
    link: "/our-companies/montecristo-social-club",
    image: MSC,
  },
  {
    company: "JR Cigars",
    name: "JR Cigars",
    info: "World's Largest Online Cigar Store. JR Cigar is one of the largest retailers of cigars in North America. The site, JRCigars.com attracts over 100,000 unique users each month.",
    link: "/our-companies/jr-cigars",
    image: JRcigars,
  },
  {
    company: "JR Cigars",
    name: "Cigars.com",
    info: "Powered by you. Cigars.com is the best place to buy cigars online. Shop top cigar brands, premium cigars, humidors, cigar accessories and more.",
    link: "/our-companies/cigars.com",
    image: CigarsCom,
  },
  {
    company: "JR Cigars",
    name: "Serious Cigars",
    info: "Premium Cigars Brought to You Since 1997. Shop cigars, humidors, samplers, cigar lighters and accessories at one of the finest and most legendary online cigar stores around.",
    link: "/our-companies/serious-cigars",
    image: SeriousCigars,
  },
  {
    company: "JR Cigars",
    name: "Beat The Dealer",
    info: "Beat The Dealer, brought to you by JR Cigar, is our daily game that lets you play to WIN our daily deal and other cigar prizes. Play your chance to win today! Online and in the Google Play store.",
    link: "/our-companies/beat-the-dealer",
    image: BeatTheDealer,
  },
  {
    company: "Casa de Montecristo",
    name: "Casa de Montecristo",
    info: "Casa de Montecristo gives the adult cigar consumer the premier cigar experience, featuring large selections of premium cigars, modern lounges, walk-in humidors and full bars across the multiple locations in the United States.",
    link: "/our-companies/casa-de-montecristo",
    image: CasaDeMontecristo,
  },
  {
    company: "JR Cigars",
    name: "Santa Clara",
    info: "Santa Clara Cigars is one of the largest tobacco product wholesalers in the country, selling tobacco products and accessories to licensed tobacco retailers.",
    link: "/our-companies/santa-clara",
    image: SantaClara,
  }
];



// WEBPACK FOOTER //
// ./src/containers/OurCompanies/OurCompaniesData.ts